import React, { useEffect, useState } from 'react';
import { fetchCarrierCodes, payCarrier } from '../../services/api';
import CarrierPayment from '../CarrierPayment/CarrierPayment';
import MySelect from '../MySelect/MySelect';
import MessageBox from '../MessageBox/MessageBox';
import './carrierBillingComponent.css';

export default function CarrierBillingComponent({ searchParams, applyFilters, removeFilters }) {
  const [carrierCodes, setCarrierCodes] = useState([]);
  const [carrierValue, setCarrierValue] = useState('');
  const [showCarrierPayment, setShowCarrierPayment] = useState(false);
  const [showMessageBox, setShowMessageBox] = useState(false);
  const [error, setError] = useState('');
  const [messageBoxConfig, setMessageBoxConfig] = useState({
    message: '',
    type: 'ok',
    onConfirm: null,
    onCancel: null,
  });

  useEffect(() => {
    const fetchCodes = async () => {
      try {
        const fetchedCarrierCodes = await fetchCarrierCodes();
        setCarrierCodes(fetchedCarrierCodes);
      } catch (error) {
        console.error('Erreur lors de la récupération des codes transporteurs:', error);
      }
    };

    const carrier_searched = searchParams.get('carrier');

    if (carrier_searched) {
      setCarrierValue(carrier_searched);
    }

    fetchCodes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCarrierChange = e => {
    setCarrierValue(e.target.value);
    if (e.target.value !== '') {
      applyFilters([e.target.name, e.target.value]);
    } else {
      removeFilters(['carrier']);
    }
  };

  const handleShowCarrierPayment = () => {
    if (carrierValue) {
      setShowCarrierPayment(true);
    } else {
      setError('Le nom du transporteur doit être renseigné');
    }
  };

  const handleCloseCarrierPayment = () => {
    setShowCarrierPayment(false);
  };

  const handleConfirmCarrierPayment = async (
    selected_shipments,
    invoice_number,
    payment_date,
    payment_number
  ) => {
    const PayCarrier = async (selected_shipments, invoice_number, payment_date, payment_number) => {
      try {
        const response = await payCarrier(
          selected_shipments,
          invoice_number,
          payment_date,
          payment_number
        );
        return response;
      } catch (error) {
        setMessageBoxConfig({
          message: `Une erreur est survenue lors du règlement tps: ${error}`,
          type: 'ok',
          onConfirm: () => setShowMessageBox(false),
          onClose: () => setShowMessageBox(false),
        });
        setShowMessageBox(true);
      }
    };

    const response = await PayCarrier(
      selected_shipments,
      invoice_number,
      payment_date,
      payment_number
    );

    if (response) {
      setMessageBoxConfig({
        message: `Le règlement transporteur a bien été enregistré.`,
        type: 'ok',
        onConfirm: () => setShowMessageBox(false),
        onClose: () => setShowMessageBox(false),
      });
      setShowMessageBox(true);
      setShowCarrierPayment(false);
    }
  };

  return (
    <form className="table-sub-heading-component">
      <div className="table-sub-heading-component input-group">
        <h3>Code transporteur:</h3>
        <MySelect
          values={carrierCodes}
          isCreatable={false}
          value={carrierValue ? { value: carrierValue, label: carrierValue } : null}
          onChange={selectedOption =>
            handleCarrierChange({
              target: { name: 'carrier', value: selectedOption ? selectedOption.value : '' },
            })
          }
          validationType="str"
        />
      </div>
      <button
        type="button"
        className="table-sub-heading-component edit-button carrier-billing"
        onClick={handleShowCarrierPayment}
      >
        Régler une facture tps
      </button>
      {error !== '' && <p className="error">{error}</p>}

      {showCarrierPayment && (
        <CarrierPayment
          shipment_filters={searchParams}
          onClose={handleCloseCarrierPayment}
          onConfirm={handleConfirmCarrierPayment}
        />
      )}
      {showMessageBox && (
        <MessageBox
          message={messageBoxConfig.message}
          onClose={() => setShowMessageBox(false)}
          onConfirm={messageBoxConfig.onConfirm}
          onCancel={messageBoxConfig.onCancel}
          type={messageBoxConfig.type}
          technicalDetails={messageBoxConfig.technicalDetails}
        />
      )}
    </form>
  );
}
